module.exports = __webpack_public_path__ + "static/media/Mo_hinh_he_thong_1.53f6593a.png";